/* eslint-disable */
import { scrollToFootnote } from '~/components/footnotes/footnote-renderer';

export function FootnoteReferenceNgc({ reference, ariaLabel }: { reference: string | number; ariaLabel?: string }) {
	if (!reference) return null;
	const footnoteRef = Number(reference) ? String.fromCharCode(Number(reference) + 'a'.charCodeAt(0)) : reference;

	return (
		<a
			href="#"
			style={{ textDecoration: 'none' }}
			onClick={(e) => {
				e.preventDefault();
				scrollToFootnote(reference);
			}}
			aria-label={ariaLabel}>
			<sup>{footnoteRef}</sup>
		</a>
	);
}
